const doc = [({"en":({"js":({"users":({"edit":({"form":({"relatives":({"add_relative":"Add relative"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;